import React from 'react';

const StudentDashboard = () => (
  <div className="min-h-screen bg-bg text-text flex flex-col items-center py-8">
    <h1 className="text-2xl font-bold mb-4 text-primary">Student Dashboard</h1>
    <p className="text-lg">Welcome, Student! Here you can view and complete your assigned skill sheets.</p>
    {/* Add student-specific features here */}
  </div>
);

export default StudentDashboard;
